export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5464.a9f98c95.jpg";